<template>
  <div class="wrapper">
    <v-tabs
      v-model="activeTab"
      class="mt-2 elevation-1"
    >
      <v-tab v-for="(template, index) in templateList" :key="index">
        {{ template.name }}
      </v-tab>
      <v-spacer></v-spacer>
      <div class="v-tabs__div">
        <icon-button-with-tooltip
          className="add-finding-btn"
          color="grey darken-1"
          flat
          small
          iconName="add"
          tooltipText="Add new template"
          @click="addNewTemplate"
          :disabled="!intervention.interventionId"
        ></icon-button-with-tooltip>
      </div>
      <v-tab-item
        v-for="(template, index) in templateList"
        :key="index"
      >
        <v-card flat>
          <v-card-text>
            <InterventionRecordsForm
              :data="transformDataForRecordsForm(template.content)"
              :hidden-params="{}"
              :transI18n="transI18n"
              @change="handleInterventionChange($event, template)"
            />
          </v-card-text>
        </v-card>

        <v-layout align-center justify-center class="pb-2">
          <v-btn flat outline color="red" @click.stop="openDeleteDialog(template)">
            <v-icon>delete</v-icon>
            Delete Template
          </v-btn>
        </v-layout>
      </v-tab-item>
    </v-tabs>

    <div v-if="!templateList || templateList.length === 0" class="no-data">
      <p v-if="!intervention.interventionId">Please select an intervention first.</p>
      <p v-else>No Template</p>
    </div>

    <ConfirmDialogSmall
      :showDialog="deleteDialog"
      :title="'Delete Template'"
      :message="deleteMessage"
      :onConfirm="onDeleteConfirm.bind(this)"
      :onCancel="onDeleteCancel.bind(this)"
    ></ConfirmDialogSmall>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import IconButtonWithTooltip from "@/components/IconButtonWithTooltip.vue";
import ConfirmDialogSmall from "@/components/ConfirmDialogSmall.vue";
import InterventionRecordsForm from "@/components/examinations/InterventionRecordsForm.vue";

export default {
  name: "PreviewIntervention",
  props: {
    transI18n: {
      type: Function,
      required: true,
    },
    intervention: {
      type: Object,
      required: true,
      default: () => ({}),
    }
  },
  components: {
    IconButtonWithTooltip,
    ConfirmDialogSmall,
    InterventionRecordsForm,
  },
  data() {
    return {
      deleteDialog: false,
      deleteMessage: "",
      activeTab: null,
      templateToDelete: null,
    };
  },
  computed: {
    templateList() {
      if (!this.intervention.interventionId) {
        return [];
      }
      return this.$store.getters['templates/templatesByInterventionId'](this.intervention.interventionId);
    }
  },
  methods: {
    ...mapActions('templates', [
      'addTemplate',
      'deleteTemplate',
      'updateTemplate',
    ]),
    transformDataForRecordsForm(data) {
      if (!data || typeof data !== 'object') {
        return [];
      }

      const groupedByCategory = Object.entries(data)
        .filter(([key]) => key !== 'interven_id')
        .reduce((acc, [key, item]) => {
          const category = item.category;
          if (!acc[category]) {
            acc[category] = {
              category: category,
              items: [],
            };
          }
          acc[category].items.push({
            ...item,
            config: {
              inputType: item.inputType,
              options: item.options,
              field: key,
              question: item.options ? Object.values(item.options)[0] : '',
            },
          });
          return acc;
        }, {});

      return Object.values(groupedByCategory);
    },
    handleInterventionChange({ newValue, qID }, template) {
      const newContent = JSON.parse(JSON.stringify(template.content));
      const questionKey = Object.keys(newContent).find(key => newContent[key].questionID === qID);

      console.log('Updating question:', qID, 'with new value:', newValue);
      if (questionKey) {
        newContent[questionKey].value = newValue;
        console.log('Updated content:', newContent);
        this.updateTemplate({
          interventionId: this.intervention.interventionId,
          templateId: template.id,
          content: newContent,
        });
      }
    },
    addNewTemplate() {
      if (!this.intervention.interventionId || !this.intervention.questions) return;
      const newTemplateName = this.intervention.interventionName || `Template ${this.templateList.length + 1}`;
      this.addTemplate({
        interventionId: this.intervention.interventionId,
        name: newTemplateName,
        content: this.intervention.questions,
      });
    },
    openDeleteDialog(template) {
      this.templateToDelete = template;
      this.deleteMessage = `Are you sure you want to delete "${template.name}"?`;
      this.deleteDialog = true;
    },
    onDeleteCancel() {
      this.deleteDialog = false;
      this.templateToDelete = null;
    },
    onDeleteConfirm() {
      if (this.templateToDelete && this.intervention.interventionId) {
        this.deleteTemplate({
          interventionId: this.intervention.interventionId,
          templateId: this.templateToDelete.id,
        });
      }
      this.deleteDialog = false;
      this.templateToDelete = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/pages/page_examinationDetail.scss";

.wrapper {
  position: relative;
}
</style>
